import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import styles from "./adminmanageuser.module.css";
import { useEffect, useState } from 'react';
import { disableUser, enableUser, getAllUsers } from '../../apis/admin';
import { useCookies } from 'react-cookie';
import LoadingScreen from '../LoadingScreen';

export default function AdminManageUser() {
  const { t } = useTranslation();

  const [cookies, setCookie] = useCookies(["access_token", "user_info"]);

  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getAllUsers(cookies['access_token']).then((data) => {
      setUsers(data.data)
      setLoading(false)
    })
  }, [])

  const headers = [
    t('user_ID'),
    t('full_name'),
    t('gender'),
    t('email'),
    t('address'),
    t('city'),
    t('sign_up_date'),
    t('last_log_in'),
    t('actions')
  ];

  const lockUser = (userId) => {
    disableUser(userId, cookies['access_token'])
  }

  const unlockUser = (userId) => {
    enableUser(userId, cookies['access_token'])
  }

  return (
    loading ? <LoadingScreen />
      :
      <div className={styles.table_wrapper}>
        {headers.map((header, index) => (
          <div key={index} className={styles.table_header}>{header}</div>
        ))}
        {users.length > 0 ? (
          users.map((row) => (
            <div key={row.id} className={styles.table_row}>
              <div className={styles.table_cell}>{row.id}</div>
              <div className={styles.table_cell}>{row.name}</div>
              <div className={styles.table_cell}>{row.gender}</div>
              <div className={styles.table_cell}>{row.email}</div>
              <div className={styles.table_cell}>{row.address}</div>
              <div className={styles.table_cell}>{row.city}</div>
              <div className={styles.table_cell}>{row.signup}</div>
              <div className={styles.table_cell}>{row.lastLogin}</div>
              <div className={styles.table_cell}>
                {/* <button className={styles.iconButton1} onClick={()=>{}}>
                <EditIcon titleAccess={t('edit')} />
              </button> */}
                {row.status ?
                  <button className={styles.iconButton2} onClick={() => { lockUser(row.id) }}>
                    <LockIcon titleAccess={t('lock_account')} />
                  </button>
                  :
                  <button className={styles.iconButton2} onClick={() => { unlockUser(row.id) }}>
                    <LockOpenIcon titleAccess={t('unlock_account')} />
                  </button>
                }
              </div>
            </div>
          ))
        ) : (
          <div className={styles.no_data}>No data available</div>
        )}
      </div>
  );
}
